import React, { useEffect, useState } from 'react'
import { Get_Api } from '../API_URL';
import { useNavigate } from 'react-router-dom';

function Blogs() {
    const naviagate = useNavigate()
    const [AllBlogs, setAllBlogs] = useState([]);
    const [IsUploading, setIsUploading] = useState(false);

    const Get_All_Blogs = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api('api/admin/GetAllBlogs');
            setAllBlogs(response?.data);
            setIsUploading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        Get_All_Blogs();
    }, []);

    const detailpage = (id) => {
        naviagate(`/BlogDetails/${id}`);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return (
        <>
            {IsUploading && (
                <div className="loading-text">Loading...</div>
            )}
            <div className="grid md:grid-cols-3 grid-cols-1 gap-[30px]">
                {AllBlogs?.map((blog, index) => (
                    <div key={index} style={{ backgroundImage: `url(${blog?.Image || '/assets/home/item4.png'})` }} className="our-card">
                        <div className="absolute top-[30px] flex w-full justify-between px-[30px]">
                            <button className="bg-[#00725d] text-[#FFFFFF] rounded-[50px] py-[6px] px-[14px] font-[400] text-[18px] leading-[18px]">
                                {blog?.Tag}
                            </button>
                            <img onClick={() => { detailpage(blog?._id) }} src="/assets/home/Link.svg" alt="" />
                        </div>
                        <div className="bottom-[30px] absolute p-[20px] rounded-[20px] left-[50%] translate-x-[-50%] max-w-[85%] w-full mx-auto bg-[#00725d66]">
                            <h6 className="font-[500] text-[24px] text-[#FFFFFF] leading-[28px] pb-[10px]">
                                {blog?.Heading}
                            </h6>
                            <p className="font-[400] text-[16px] text-[#FFFFFF] leading-[24px]">
                                {blog?.Description}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

export default Blogs